var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _polygon, _path, _path2, _polygon2, _polygon3, _polygon4, _polygon5, _path3, _polygon6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSprite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down-circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 16a16 16 0 0 1-16 16 16 16 0 0 1-16-16 16 16 0 0 1 16-16 16 16 0 0 1 16 16zm-16 8 8-8h-4.8v-6.4h-6.4v6.4h-4.8z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 0H9.00008V12L14.5001 6.5L15.9201 7.92L8.00008 15.84L0.0800781 7.92L1.50008 6.5L7.00008 12V0Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left-solid",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 10.286h12v3.4286h-12zm-12 1.7143 12-12v24z",
    strokeWidth: 1.7143
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 13.98v4.0404h-24.242l11.111 11.111-2.8687 2.8687-16-16 16-16 2.8687 2.8687-11.111 11.111z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right-solid",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 13.714h-12v-3.4286h12zm12-1.7143-12 12v-24z",
    strokeWidth: 1.7143
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-down-alt",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.71 2.44-1.41 1.41 5.71 5.71 5.71-5.71-1.41-1.41-4.29 4.29z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 24-16-16h32z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-left-alt",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.15 0.29 1.41 1.41-4.29 4.29 4.29 4.29-1.41 1.41-5.71-5.71z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-right-alt",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.85 0.29-1.41 1.41 4.29 4.29-4.29 4.29 1.41 1.41 5.71-5.71z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-up",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 8-16+16h32z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-alt",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.41 5.71-15.41 15.41-7.41-7.41 2.83-2.83 4.59 4.59 12.59-12.59 2.83 2.83z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-decagram",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 11.9991L20.56 9.21906L20.9 5.53906L17.29 4.71906L15.4 1.53906L12 2.99906L8.6 1.53906L6.71 4.71906L3.1 5.52906L3.44 9.20906L1 11.9991L3.44 14.7791L3.1 18.4691L6.71 19.2891L8.6 22.4691L12 20.9991L15.4 22.4591L17.29 19.2791L20.9 18.4591L20.56 14.7791L23 11.9991ZM10 16.9991L6 12.9991L7.41 11.5891L10 14.1691L16.59 7.57906L18 8.99906L10 16.9991Z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.14 1.57-5.77 5.77-2.50-2.50-1.54 1.54 4.04 4.04 7.32-7.32z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    viewBox: "0 0 96 102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0c-1.0927 0-2 0.907-2 2v92c0 1.0927 0.907 2 2 2h86c1.0927 0 2-0.907 2-2v-92c0-1.0927-0.907-2-2-2zm0 2h86v92h-86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 100h81c1.1046 0 2-0.895 2-2v-87c0-0.552 0.448-1 1-1s1 0.448 1 1v87c0 2.209-1.791 4-4 4h-81c-0.552 0-1-0.448-1-1s0.448-1 1-1z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "database",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4C10.107 4 5.333 6.387 5.333 9.333c0 2.947 4.774 5.334 10.667 5.334s10.667-2.387 10.667-5.334C26.667 6.387 21.893 4 16 4ZM5.333 12v4c0 2.947 4.774 5.333 10.667 5.333S26.667 18.947 26.667 16v-4c0 2.947-4.774 5.333-10.667 5.333S5.333 14.947 5.333 12Zm0 6.667v4C5.333 25.613 10.107 28 16 28s10.667-2.387 10.667-5.333v-4C26.667 21.613 21.893 24 16 24S5.333 21.613 5.333 18.667Z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "discord",
    viewBox: "0 0 22 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36391 1.5075C4.78801 0.80325 6.31072 0.291433 7.90268 0C8.09819 0.373607 8.3266 0.876116 8.48409 1.27586C10.1764 1.00687 11.8531 1.00687 13.5143 1.27586C13.6717 0.876116 13.9053 0.373607 14.1026 0C15.6963 0.291433 17.2207 0.80513 18.6448 1.51123C21.5172 6.09902 22.2959 10.5729 21.9066 14.9832C20.0014 16.4869 18.1551 17.4004 16.34 17.9981C15.8918 17.3462 15.4921 16.6532 15.1478 15.9228C15.8036 15.6594 16.4317 15.3344 17.0252 14.9571C16.8677 14.8338 16.7137 14.7049 16.5649 14.5722C12.945 16.3618 9.01184 16.3618 5.43516 14.5722C5.28461 14.7049 5.13063 14.8338 4.97489 14.9571C5.57014 15.3362 6.19998 15.6613 6.85579 15.9247C6.51145 16.6532 6.11346 17.3481 5.66357 18C3.84667 17.4022 1.99865 16.4888 0.0935059 14.9832C-0.363321 9.87051 0.873892 5.43775 3.36391 1.5075ZM14.6546 12.2709C15.7413 12.2709 16.6324 11.1986 16.6324 9.89291C16.6324 8.58719 15.7603 7.5131 14.6546 7.5131C13.5489 7.5131 12.6577 8.58531 12.6768 9.89291C12.675 11.1986 13.5489 12.2709 14.6546 12.2709ZM7.34549 12.2709C8.43215 12.2709 9.32331 11.1986 9.32331 9.89291C9.32331 8.58719 8.45121 7.5131 7.34549 7.5131C6.23979 7.5131 5.34864 8.58531 5.36767 9.89291C5.36767 11.1986 6.23979 12.2709 7.34549 12.2709Z",
    fill: "currentColor"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "document",
    viewBox: "0 0 10 13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 4.55H9.0625L5.625 0.975V4.55ZM1.25 0H6.25L10 3.9V11.7C10 12.0448 9.8683 12.3754 9.63388 12.6192C9.39946 12.863 9.08152 13 8.75 13H1.25C0.55625 13 0 12.415 0 11.7V1.3C0 0.5785 0.55625 0 1.25 0ZM6.875 10.4V9.1H1.25V10.4H6.875ZM8.75 7.8V6.5H1.25V7.8H8.75Z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "dots-vertical",
    viewBox: "0 0 4 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2.53043 12 3.03914 12.2107 3.41421 12.5858C3.78929 12.9609 4 13.4696 4 14C4 14.5304 3.78929 15.0391 3.41421 15.4142C3.03914 15.7893 2.53043 16 2 16C1.46957 16 0.96086 15.7893 0.585787 15.4142C0.210714 15.0391 0 14.5304 0 14C0 13.4696 0.210714 12.9609 0.585787 12.5858C0.96086 12.2107 1.46957 12 2 12ZM2 6C2.53043 6 3.03914 6.21071 3.41421 6.58579C3.78929 6.96086 4 7.46957 4 8C4 8.53043 3.78929 9.03914 3.41421 9.41421C3.03914 9.78929 2.53043 10 2 10C1.46957 10 0.96086 9.78929 0.585787 9.41421C0.210714 9.03914 0 8.53043 0 8C0 7.46957 0.210714 6.96086 0.585787 6.58579C0.96086 6.21071 1.46957 6 2 6ZM2 0C2.53043 0 3.03914 0.210714 3.41421 0.585786C3.78929 0.960859 4 1.46957 4 2C4 2.53043 3.78929 3.03914 3.41421 3.41421C3.03914 3.78929 2.53043 4 2 4C1.46957 4 0.96086 3.78929 0.585787 3.41421C0.210714 3.03914 0 2.53043 0 2C0 1.46957 0.210714 0.960859 0.585787 0.585786C0.96086 0.210714 1.46957 0 2 0Z",
    fill: "#C0C0D3"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 11H9V5H11V11ZM11 15H9V13H11V15ZM10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "external-link",
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 0.25c-1.5099 0-2.75 1.2401-2.75 2.75v9c0 1.5099 1.2401 2.75 2.75 2.75h9c1.5099 0 2.75-1.2401 2.75-2.75v-2h-1.5v2c0 0.69929-0.55071 1.25-1.25 1.25h-9c-0.69925 0-1.25-0.55072-1.25-1.25v-9c0-0.69924 0.55076-1.25 1.25-1.25h2v-1.5z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 0.25v1.5h4.1875l-6.7188 6.7188 1.0625 1.0625 6.7188-6.7188v4.1875h1.5v-6.7441h-0.75v-0.0058594h-2.832z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  })), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.04004C6.5 2.04004 2 6.53004 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85004C10.44 7.34004 11.93 5.96004 14.22 5.96004C15.31 5.96004 16.45 6.15004 16.45 6.15004V8.62004H15.19C13.95 8.62004 13.56 9.39004 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C15.9164 21.5879 18.0622 20.3856 19.6099 18.5701C21.1576 16.7546 22.0054 14.4457 22 12.06C22 6.53004 17.5 2.04004 12 2.04004Z",
    fill: "#848498"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "fortmatic",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.028 1.74e-4h15.608v8.0038h-23.412v23.965h-7.8039v-31.969h7.8039zm7.8044 23.968h-7.7584v-7.9572h15.557v8.2372c0 2.0477-0.79283 4.0116-2.2041 5.4599-1.4113 1.4484-3.3257 2.2627-5.3222 2.264h-0.27292z",
    clipRule: "evenodd",
    fill: "#6851ff",
    fillRule: "evenodd",
    strokeWidth: 0.87
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "gear",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.003 16.2c-1.1451 0-2.2434-0.4425-3.0531-1.2302s-1.2646-1.856-1.2646-2.9698 0.4549-2.1822 1.2646-2.9698 1.908-1.2302 3.0531-1.2302c1.1452 0 2.2434 0.4425 3.0532 1.2302 0.8097 0.78765 1.2646 1.856 1.2646 2.9698s-0.45495 2.1822-1.2646 2.9698c-0.80985 0.78765-1.908 1.2302-3.0532 1.2302zm9.1662-3.036c0.04935-0.384 0.08625-0.768 0.08625-1.164s-0.0369-0.792-0.08625-1.2l2.603-1.956c0.23445-0.18 0.2961-0.504 0.14805-0.768l-2.4674-4.152c-0.14805-0.264-0.48105-0.372-0.75255-0.264l-3.0717 1.2c-0.64155-0.468-1.3077-0.876-2.085-1.176l-0.45645-3.18c-0.04935-0.288-0.3084-0.504-0.6168-0.504h-4.9347c-0.3084 0-0.56744 0.216-0.61678 0.504l-0.45645 3.18c-0.77721 0.3-1.4434 0.708-2.0849 1.176l-3.0718-1.2c-0.27141-0.108-0.6045 0-0.75254 0.264l-2.4673 4.152c-0.16038 0.264-0.086355 0.588 0.14804 0.768l2.603 1.956c-0.04935 0.408-0.086355 0.804-0.086355 1.2s0.037005 0.78 0.086355 1.164l-2.603 1.992c-0.23439 0.18-0.30842 0.504-0.14804 0.768l2.4673 4.152c0.14804 0.264 0.48112 0.36 0.75254 0.264l3.0718-1.212c0.6415 0.48 1.3077 0.888 2.0849 1.188l0.45645 3.18c0.04935 0.288 0.30838 0.504 0.61678 0.504h4.9347c0.3084 0 0.56745-0.216 0.6168-0.504l0.45645-3.18c0.7773-0.312 1.4434-0.708 2.085-1.188l3.0717 1.212c0.2715 0.096 0.6045 0 0.75255-0.264l2.4674-4.152c0.14805-0.264 0.0864-0.588-0.14805-0.768z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "gitbook-alt",
    viewBox: "0 0 20 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00226 11.6679C9.3147 11.6679 9.59589 11.9102 9.59589 12.2433C9.59589 12.5462 9.34594 12.8188 9.00226 12.8188C8.68983 12.8188 8.40863 12.5765 8.40863 12.2433C8.40863 11.9102 8.68983 11.6679 9.00226 11.6679ZM18.1879 8.15464C17.8754 8.15464 17.5942 7.91235 17.5942 7.5792C17.5942 7.27633 17.8442 7.00375 18.1879 7.00375C18.5003 7.00375 18.7815 7.24604 18.7815 7.5792C18.7815 7.88206 18.5003 8.15464 18.1879 8.15464ZM18.1879 5.82257C17.1881 5.82257 16.3757 6.61002 16.3757 7.5792C16.3757 7.76092 16.407 7.94264 16.4695 8.12436L10.502 11.2136C10.1583 10.729 9.59589 10.4564 9.00226 10.4564C8.3149 10.4564 7.69003 10.8502 7.3776 11.4256L2.0037 8.6998C1.44132 8.39694 1.00391 7.51862 1.06639 6.6706C1.09764 6.24658 1.25385 5.91343 1.47256 5.79228C1.62878 5.70142 1.785 5.73171 2.0037 5.82257L2.03494 5.85286C3.47215 6.57974 8.12744 8.9421 8.3149 9.03296C8.62734 9.15411 8.78356 9.21468 9.3147 8.97239L18.9377 4.12651C19.0939 4.06594 19.2502 3.94479 19.2502 3.73279C19.2502 3.46021 18.969 3.33906 18.969 3.33906C18.4066 3.09677 17.563 2.70304 16.7507 2.3396C15.001 1.55215 13.0014 0.643545 12.1266 0.189245C11.3768 -0.204482 10.7519 0.128671 10.6582 0.189245L10.4395 0.280105C6.47153 2.21845 1.22261 4.73225 0.910176 4.91397C0.379035 5.21684 0.0353555 5.85286 0.00411193 6.64031C-0.0583752 7.88206 0.59774 9.18439 1.53505 9.63869L7.22138 12.4856C7.34635 13.3337 8.12744 14 9.00226 14C10.0021 14 10.7831 13.2428 10.8144 12.2736L17.0631 9.00267C17.3755 9.24496 17.7817 9.36611 18.1879 9.36611C19.1877 9.36611 20 8.57866 20 7.60948C20 6.61002 19.1877 5.82257 18.1879 5.82257Z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "github-small",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.68678 0 7.38642 0.265079 6.17317 0.780103C4.95991 1.29513 3.85752 2.05001 2.92893 3.00165C1.05357 4.92357 0 7.53026 0 10.2483C0 14.778 2.87 18.6211 6.84 19.9841C7.34 20.0661 7.5 19.7484 7.5 19.4717C7.5 19.236 7.5 18.5904 7.5 17.7398C4.73 18.3547 4.14 16.3665 4.14 16.3665C3.68 15.1777 3.03 14.86 3.03 14.86C2.12 14.2246 3.1 14.2451 3.1 14.2451C4.1 14.3168 4.63 15.3007 4.63 15.3007C5.5 16.8584 6.97 16.3972 7.54 16.1513C7.63 15.4851 7.89 15.0342 8.17 14.778C5.95 14.5218 3.62 13.6404 3.62 9.73586C3.62 8.5983 4 7.6862 4.65 6.95858C4.55 6.70237 4.2 5.63655 4.75 4.25303C4.75 4.25303 5.59 3.97633 7.5 5.29836C8.29 5.07289 9.15 4.96016 10 4.96016C10.85 4.96016 11.71 5.07289 12.5 5.29836C14.41 3.97633 15.25 4.25303 15.25 4.25303C15.8 5.63655 15.45 6.70237 15.35 6.95858C16 7.6862 16.38 8.5983 16.38 9.73586C16.38 13.6507 14.04 14.5115 11.81 14.7678C12.17 15.0855 12.5 15.7106 12.5 16.6637C12.5 18.037 12.5 19.1438 12.5 19.4717C12.5 19.7484 12.66 20.0764 13.17 19.9841C17.14 18.6109 20 14.778 20 10.2483C20 8.90245 19.7413 7.5698 19.2388 6.32643C18.7362 5.08305 17.9997 3.95329 17.0711 3.00165C16.1425 2.05001 15.0401 1.29513 13.8268 0.780103C12.6136 0.265079 11.3132 0 10 0Z",
    fill: "currentColor"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "github",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 16.42 4.87 20.17 8.84 21.5C9.34 21.58 9.5 21.27 9.5 21C9.5 20.77 9.5 20.14 9.5 19.31C6.73 19.91 6.14 17.97 6.14 17.97C5.68 16.81 5.03 16.5 5.03 16.5C4.12 15.88 5.1 15.9 5.1 15.9C6.1 15.97 6.63 16.93 6.63 16.93C7.5 18.45 8.97 18 9.54 17.76C9.63 17.11 9.89 16.67 10.17 16.42C7.95 16.17 5.62 15.31 5.62 11.5C5.62 10.39 6 9.5 6.65 8.79C6.55 8.54 6.2 7.5 6.75 6.15C6.75 6.15 7.59 5.88 9.5 7.17C10.29 6.95 11.15 6.84 12 6.84C12.85 6.84 13.71 6.95 14.5 7.17C16.41 5.88 17.25 6.15 17.25 6.15C17.8 7.5 17.45 8.54 17.35 8.79C18 9.5 18.38 10.39 18.38 11.5C18.38 15.32 16.04 16.16 13.81 16.41C14.17 16.72 14.5 17.33 14.5 18.26C14.5 19.6 14.5 20.68 14.5 21C14.5 21.27 14.66 21.59 15.17 21.5C19.14 20.16 22 16.42 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2V2Z",
    fill: "#848498"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "i",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 4,
    height: 8
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "ledger",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("title", null, "Fichier 1"), /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#142533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m26.876 2.5157e-5h-14.576v19.664h19.68v-14.576a5.088 5.088 0 0 0-5.104-5.088z",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6 0h-2.512a5.088 5.088 0 0 0-5.088 5.088v2.512h7.6z",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b",
    transform: "matrix(1.6 0 0 1.6 0 -.084)",
    points: "4.75 7.59 4.75 12.34 0 12.34 0 7.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.39 31.926h2.512a5.088 5.088 0 0 0 5.088-5.104v-2.432h-7.6z",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(1.6 0 0 1.6 .156 .102)",
    points: "12.34 15.18 12.34 19.93 7.59 19.93 7.59 15.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 24.39v2.512a5.088 5.088 0 0 0 5.088 5.088h2.512v-7.6z",
    strokeWidth: 1.6
  })))))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightning",
    viewBox: "0 0 10 12"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42843 0L0.571289 6H3.99986L3.14272 12L9.99986 6H6.57129L7.42843 0Z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "medium-alt",
    viewBox: "0 0 14 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.768H13.216C13.0178 1.768 12.738 2.0895 12.738 2.295V9.745C12.738 9.951 13.019 10.232 13.216 10.232H13.75V12H8.912V10.232H9.925V2.4H9.875L7.511 12H5.680L3.346 2.4H3.288V10.232H4.3V12H0.25V10.232H0.769C0.982 10.232 1.262 9.951 1.262 9.745V2.295C1.262 2.089 0.982 1.768 0.769 1.768H0.25V0H5.314L6.977 6.947H7.023L8.701 0H13.75V1.768Z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "substack-small",
    viewBox: "150 150 700 700"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "M765.833374,488.175018 C765.880432,491.510376 765.927490,494.845734 765.604980,498.770386      C765.156982,502.573090 765.078491,505.786560 764.795532,509.376099 C764.499878,511.526093 764.408813,513.300049 764.317688,515.073975 C764.810669,517.626831 765.303650,520.179626 765.301086,523.608521 C764.873596,524.988342 764.941589,525.492249 765.009583,525.996094 C765.330444,528.476318 765.651306,530.956604 765.496338,534.176636 C764.680359,536.277649 764.340149,537.638855 764.000000,539.250000 C764.000000,539.500000 764.000000,540.000000 764.000000,540.250000 C764.000000,540.500000 764.000000,541.000000 764.129822,541.287964 C764.784241,542.712341 765.308899,543.848694 765.833496,544.985107 C765.878601,556.865601 765.923706,568.746094 765.382996,581.377075 C764.531433,582.418396 764.265747,582.709167 764.420044,583.488220 C765.166931,584.254761 765.493835,584.533081 765.820801,584.811340 C765.862915,586.129456 765.905029,587.447632 765.372803,589.436279 C765.090210,593.612610 765.382080,597.118530 765.673950,600.624390 C765.770020,613.563416 765.866150,626.502380 765.523804,640.113159 C765.334656,641.511841 765.583984,642.238770 765.833313,642.965759 C765.871460,649.809814 765.909668,656.653809 765.363098,664.291321 C764.935364,668.261353 765.092468,671.437927 765.249512,674.614502 C765.499634,676.686340 765.955444,678.757202 765.965881,680.830261 C766.026733,692.919617 765.983093,705.009583 765.730835,717.935913 C765.391785,722.374878 765.296692,725.977173 765.201660,729.579468 C765.467773,730.966492 765.963013,732.353088 765.965759,733.740601 C766.006958,754.486267 765.983154,775.232056 765.597900,796.638733 C764.814026,798.533142 764.406982,799.766541 764.000000,801.333313 C764.000000,802.111084 764.000000,802.555542 763.999817,803.418762 C763.428284,805.922607 762.856873,808.007690 762.285461,810.092773 C760.275269,809.363708 758.300720,808.502808 756.243896,807.946350 C754.531555,807.483032 752.722412,807.377197 750.956177,807.113037 C750.373108,806.965881 749.789978,806.818726 749.007080,806.052124 C744.894348,802.581604 741.198975,799.339478 736.999878,797.002441 C733.611694,795.116821 729.615601,794.323547 725.889221,793.045593 C717.980469,788.898010 709.993591,784.891663 702.180603,780.570923 C689.363098,773.482605 676.663208,766.181641 663.905151,758.985657 C645.189209,748.429260 626.485901,737.850220 607.738464,727.350098 C594.952637,720.188843 582.072815,713.195251 569.284668,706.037964 C551.106934,695.864197 532.981567,685.596680 514.817200,675.398926 C511.410126,673.486206 508.060394,671.337708 504.422180,670.023132 C502.409912,669.296204 499.452515,669.316406 497.607819,670.294678 C484.666473,677.157349 471.881134,684.316345 459.091034,691.461365 C446.308105,698.602417 433.577271,705.836731 420.824371,713.031494 C402.112610,723.588074 383.429321,734.195618 364.681580,744.687988 C348.914093,753.512268 333.042664,762.150757 317.270508,770.966736 C299.091278,781.128235 280.995361,791.438843 262.812897,801.594604 C254.589310,806.187866 246.244125,810.563416 237.025620,815.538879 C237.025620,705.519409 237.025620,596.223755 237.602631,486.252991 C238.735321,485.109619 239.291000,484.641357 239.846695,484.173096 C240.673935,484.115662 241.501175,484.007904 242.328400,484.007904 C326.336365,484.009430 410.344299,484.019135 495.131744,484.500977 C498.335571,484.704590 500.759918,484.435577 503.184265,484.166565 C504.179565,484.111145 505.174866,484.007172 506.170166,484.007202 C590.923340,484.008118 675.676453,484.017059 761.122253,484.537811 C763.154358,486.091797 764.493896,487.133423 765.833374,488.175018 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M428.000000,214.000000      C540.795959,214.000000 653.091919,214.000000 765.693848,214.000000  C765.693848,237.711960 765.693848,261.099731 765.693848,284.744324  C589.645691,284.744324 413.717804,284.744324 237.395050,284.744324  C237.395050,261.467529 237.395050,238.078842 237.395050,214.000000  C300.665649,214.000000 364.082825,214.000000 428.000000,214.000000 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.833618,352.000305      C765.880676,373.690765 765.927734,395.381226 765.597534,417.562866  C764.480103,418.369354 763.740051,418.684662 762.531372,419.000000  C588.375122,419.000000 414.687561,419.000000 240.910568,418.591919  C240.547485,415.549927 240.048050,412.916992 240.036880,410.281982  C239.964920,393.315369 240.044846,376.348053 239.954773,359.381622  C239.939941,356.586121 239.333191,353.793793 239.408081,351.089417  C242.952850,351.452576 246.089493,351.965088 249.226257,351.965790  C421.428680,352.004425 593.631104,352.000183 765.833618,352.000305 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.890137,351.592529      C593.631104,352.000183 421.428680,352.004425 249.226257,351.965790  C246.089493,351.965088 242.952850,351.452576 239.127899,351.080322  C238.252823,350.975586 238.066025,350.969421 237.879242,350.963226  C238.439957,350.318298 238.904526,349.278900 239.582184,349.113708  C240.841736,348.806702 242.225555,349.001068 243.557648,349.001068  C415.584930,348.999847 587.612183,348.992157 759.639404,349.090546  C761.742249,349.091736 763.844299,350.456482 765.890137,351.592529 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M241.000000,419.000000      C414.687561,419.000000 588.375122,419.000000 762.531372,419.305542  C762.999939,420.018463 762.999817,420.425842 762.999695,420.833191  C761.171448,420.888763 759.343201,420.992889 757.514954,420.992981  C586.316589,421.000427 415.118225,421.003723 243.919861,420.952850  C241.971436,420.952271 240.023224,420.242523 238.474976,419.431793  C239.583359,418.999847 240.291672,418.999939 241.000000,419.000000 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M240.910568,418.591919      C240.291672,418.999939 239.583359,418.999847 238.520874,418.999573  C237.778473,417.782379 237.052933,416.565643 237.052170,415.348450  C237.038773,394.051788 237.114075,372.755096 237.524673,351.210815  C238.066025,350.969421 238.252823,350.975586 238.719818,350.990906  C239.333191,353.793793 239.939941,356.586121 239.954773,359.381622  C240.044846,376.348053 239.964920,393.315369 240.036880,410.281982  C240.048050,412.916992 240.547485,415.549927 240.910568,418.591919 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M726.054810,793.358582      C729.615601,794.323547 733.611694,795.116821 736.999878,797.002441      C741.198975,799.339478 744.894348,802.581604 748.882690,805.773926      C741.378784,801.967285 733.799622,797.819458 726.054810,793.358582    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M751.119385,807.421021      C752.722412,807.377197 754.531555,807.483032 756.243896,807.946350  C758.300720,808.502808 760.275269,809.363708 762.285461,810.092773  C762.856873,808.007690 763.428284,805.922607 764.300659,803.005859  C764.957031,801.584473 765.312378,800.994751 765.667664,800.405029  C765.770081,804.357788 765.872498,808.310669 765.756165,812.766235  C765.346558,813.442627 765.171387,813.630737 765.011780,813.833313  C760.435364,811.798523 755.858948,809.763733 751.119385,807.421021 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.000000,509.000000      C765.078491,505.786560 765.156982,502.573090 765.534424,499.179932      C765.796936,504.221100 765.760437,509.441986 765.248230,514.217712      C764.848328,512.181702 764.924133,510.590851 765.000000,509.000000    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M502.802216,484.096130      C500.759918,484.435577 498.335571,484.704590 495.535583,484.581665      C497.579987,484.135071 500.000092,484.080383 502.802216,484.096130    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.904053,487.807129      C764.493896,487.133423 763.154358,486.091797 761.533936,484.610168      C763.744080,483.935211 766.725769,482.991608 765.904053,487.807129    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M764.000000,539.000000      C764.340149,537.638855 764.680359,536.277649 765.418823,534.552490  C765.869202,536.187622 765.921326,538.186890 765.597839,540.593018  C764.814880,541.000000 764.407410,541.000000 764.000000,541.000000  C764.000000,541.000000 764.000000,540.500000 764.074829,540.133423  C764.244385,539.487549 764.194458,539.231934 764.000000,539.000000 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.534668,729.270752      C765.296692,725.977173 765.391785,722.374878 765.660217,718.401611      C765.844971,721.674438 765.856384,725.318237 765.534668,729.270752    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.816589,600.259521      C765.382080,597.118530 765.090210,593.612610 765.231934,589.738281      C765.763428,592.878113 765.861389,596.386414 765.816589,600.259521    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.307495,674.521240      C765.092468,671.437927 764.935364,668.261353 765.217346,664.689209  C765.692078,664.626404 765.727783,664.959167 765.448669,665.851562  C765.153870,669.037781 765.173828,671.664307 765.193848,674.290894  C765.193848,674.290894 765.365479,674.427979 765.307495,674.521240 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M763.385742,420.902527      C762.999817,420.425842 762.999939,420.018463 763.000000,419.305542      C763.740051,418.684662 764.480103,418.369354 765.526855,418.026794      C765.146301,418.990295 764.459045,419.981049 763.385742,420.902527    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.529663,674.030884      C765.173828,671.664307 765.153870,669.037781 765.169556,665.913818      C765.425354,668.201233 765.645386,670.986023 765.529663,674.030884    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M764.000000,801.000000      C764.406982,799.766541 764.814026,798.533142 765.527222,797.044189      C765.863953,797.857605 765.894592,798.926514 765.347656,800.350342      C764.513428,800.803467 764.256714,800.901733 764.000000,801.000000    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M764.129822,541.287964      C764.407410,541.000000 764.814880,541.000000 765.527832,540.999817      C765.880432,542.064880 765.927429,543.130188 765.903992,544.590271      C765.308899,543.848694 764.784241,542.712341 764.129822,541.287964    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M764.795532,509.376099      C764.924133,510.590851 764.848328,512.181702 764.677246,514.385620      C764.582092,514.998779 764.418762,515.051941 764.368225,515.062988      C764.408813,513.300049 764.499878,511.526093 764.795532,509.376099    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M239.558533,484.099487      C239.291000,484.641357 238.735321,485.109619 237.673279,485.789032      C237.868073,485.342072 238.569214,484.683990 239.558533,484.099487    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.901794,642.614685      C765.583984,642.238770 765.334656,641.511841 765.416870,640.518555      C765.822327,640.922668 765.896301,641.593140 765.901794,642.614685    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M764.000000,801.333313      C764.256714,800.901733 764.513428,800.803467 765.157349,800.539795  C765.544678,800.374451 765.591431,800.420471 765.629517,800.412720  C765.312378,800.994751 764.957031,801.584473 764.300903,802.587097  C764.000000,802.555542 764.000000,802.111084 764.000000,801.333313 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.419861,525.718445      C764.941589,525.492249 764.873596,524.988342 764.884399,523.725220      C765.252197,523.790833 765.541199,524.615845 765.419861,525.718445    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M764.000000,583.000000      C764.265747,582.709167 764.531433,582.418396 765.295288,581.802002  C765.851562,581.948059 765.909729,582.419739 765.444214,583.089722  C764.613708,583.191956 764.306824,583.095947 764.000000,583.000000 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M764.420044,583.488220      C764.306824,583.095947 764.613708,583.191956 765.376953,583.443970  C765.968323,583.858276 766.012756,584.131409 765.893677,584.615295  C765.493835,584.533081 765.166931,584.254761 764.420044,583.488220 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M765.266602,813.862793      C765.171387,813.630737 765.346558,813.442627 765.685303,813.145142      C765.729370,813.311646 765.625427,813.601990 765.266602,813.862793    z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 1,
    stroke: "none",
    d: "   M764.000000,539.250000      C764.194458,539.231934 764.244385,539.487549 764.074829,539.883423      C764.000000,540.000000 764.000000,539.500000 764.000000,539.250000    z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "medium",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7648 9.01302H16.3879C16.2479 9.01302 16.0501 9.23968 16.0501 9.38475V14.6437C16.0501 14.789 16.2479 14.987 16.3879 14.987H16.7648V16.2353H13.3501V14.987H14.0648V9.45881H14.0297L12.3608 16.2353H11.0686L9.42116 9.45881H9.37947V14.987H10.0942V16.2353H7.23535V14.987H7.60145C7.75217 14.987 7.95006 14.789 7.95006 14.6437V9.38471C7.95006 9.23963 7.75217 9.01298 7.60145 9.01298H7.23535V7.76471H10.8101L11.9838 12.6687H12.0162L13.2007 7.76471H16.7648V9.01302Z",
    fill: "white"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "metamask",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.945 0 0 .945 -.82688 .27331)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.958 1-13.134 9.7183 2.4424-5.7273z",
    fill: "#e17726",
    stroke: "#e17726"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e27625",
    stroke: "#e27625"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6628 1 13.017 9.809-2.3254-5.818z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.229 23.533-3.4946 5.3386 7.4829 2.0603 2.1436-7.2822z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.2727 23.65 2.1305 7.2822 7.47-2.0603-3.4817-5.3386z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.47 14.515-2.0786 3.1358 7.405 0.3369-0.2468-7.969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.15 14.515-5.1574-4.587-0.1689 8.0597 7.4049-0.3369z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.873 28.872 4.4819-2.1639-3.8583-3.0062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.266 26.708 4.4689 2.1639-0.6106-5.1701z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.735 28.872-4.4689-2.1639 0.3637 2.9025-0.039 1.231z",
    fill: "#d5bfb2",
    stroke: "#d5bfb2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.873 28.872 4.1572 1.9696-0.026-1.231 0.3507-2.9025z",
    fill: "#d5bfb2",
    stroke: "#d5bfb2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.108 21.784-3.7155-1.0884 2.6242-1.2051z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.513 21.784 1.0913-2.2935 2.6372 1.2051z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#cc6228",
    stroke: "#cc6228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.873 28.872 0.6496-5.3386-4.1312 0.1167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.098 23.533 0.6366 5.3386 3.4946-5.2219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.229 17.651-7.4049 0.3369 0.6885 3.7967 1.0913-2.2936 2.6372 1.2051z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.393 20.696 2.6242-1.2051 1.0913 2.2936 0.6885-3.7967-7.405-0.3369z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#e27525",
    stroke: "#e27525"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.3921 17.651 3.1049 6.0513-0.104-3.0062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.241 20.696-0.1169 3.0062 3.1049-6.0513z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.797 17.988-0.6886 3.7967 0.8704 4.4833 0.1949-5.9087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.824 17.988-0.3638 2.3584 0.1819 5.9216 0.8704-4.4833z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m20.513 21.784-0.8704 4.4833 0.6236 0.4406 3.8584-3.0062 0.1169-3.0062z",
    fill: "#f5841f",
    stroke: "#f5841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.393 20.696 0.104 3.0062 3.8583 3.0062 0.6236-0.4406-0.8704-4.4833z",
    fill: "#f5841f",
    stroke: "#f5841f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.591 30.842 0.0389-1.231-0.3377-0.2851h-4.9626l-0.3248 0.2851 0.026 1.231-4.1572-1.9696 1.455 1.1921 2.949 2.0344h5.0535l2.962-2.0344 1.442-1.1921z",
    fill: "#c0ac9d",
    stroke: "#c0ac9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.266 26.708-0.6236-0.4405h-3.6635l-0.6235 0.4405-0.3508 2.9026 0.3248-0.2851h4.9626l0.3378 0.2851z",
    fill: "#161616",
    stroke: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.517 11.353 1.1043-5.3645-1.6629-4.9887-12.692 9.3944 4.8846 4.1205 6.8983 2.0085 1.52-1.7752-0.6625-0.4795 1.0522-0.9588-0.8054-0.622 1.0523-0.8034z",
    fill: "#763e1a",
    stroke: "#763e1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 5.9887 1.1172 5.3645-0.71451 0.5313 1.0653 0.8034-0.80545 0.622 1.0523 0.9588-0.66255 0.4795 1.52 1.7752 6.8984-2.0085 4.8846-4.1205-12.692-9.3944z",
    fill: "#763e1a",
    stroke: "#763e1a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f5841f",
    stroke: "#f5841f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.049 16.523-6.8983-2.0084 2.0786 3.1358-3.1049 6.0512 4.1052-0.0518h6.1318z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.47 14.515-6.8983 2.0084-2.2994 7.1268h6.1188l4.1052 0.0518-3.1048-6.0512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.824 17.988 0.4417-7.5933 2.0006-5.4033h-8.9119l2.0006 5.4033 0.4417 7.5933 0.1689 2.3842 0.013 5.8958h3.6635l0.013-5.8958z"
  }))))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12v-2h10v2H6Z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus-circle",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#4865FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 2,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 2,
    height: 8,
    transform: "rotate(-90 4 9)",
    fill: "white"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus-thin",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6,
    height: 2,
    width: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0,
    height: 14,
    width: 2
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 8v6.5h-6.5v3h6.5v6.5h3v-6.5h6.5v-3h-6.5v-6.5z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "portis",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1584 0 0 .1584 5.5158 0)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#133444",
    points: "2.9 126.7 1.9 116.3 6.8 114.2 66.8 88.1 131.7 116.3 107.3 166.7 47.7 175.1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c42370",
    d: "m118.2 85.3c-10.7-12.9-25.9-21.3-42.5-23.5-0.4 0-0.7-0.1-1.1-0.1-5.2-0.6-10.4-0.6-15.6 0-0.4 0-0.7 0.1-1.1 0.1-16.6 2.2-31.8 10.6-42.5 23.5l-10.5 17.5c0 0.2-0.1 0.3-0.2 0.4v0.1l7.2 4.3 46 27.2 8.9 5.2v-65l-8.9 4v-9.7l8.9-4 8.9 4 45.2 20.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c4d6b",
    d: "m133.7 132.5c-0.1 21.3-9.7 41.4-26.2 54.9-6.3 5.1-13.4 9.1-21.1 11.7-6.3 2.1-12.9 3.2-19.5 3.2-37 0-66.9-32.9-66.9-69.8 0-5.5 0.7-10.9 2-16.2l64.9 38.4 64.9-38.4c1.2 5.3 1.9 10.7 1.9 16.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "66.8 65.2 57.9 69.2 57.9 61.2 59 61.6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "66.8 74.9 66.8 139.9 57.9 134.7 57.9 79"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1d4259",
    points: "129 103.2 66.8 74.9 66.8 139.9"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "4b6b9a",
    points: "129 103.2 66.8 0 66.8 74.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: 343535,
    d: "m66.8 74.9v65l-8.9-5.2-53.2-31.5c0-0.2 0.1-0.3 0.2-0.4l7.8-12.9 45.2-20.5v9.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: Infinity,
    points: "57.9 79 66.8 74.9 66.8 139.9 57.9 134.7 4.7 103.2 4.6 103.2 4.7 103.1"
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6db2d8",
    points: "4.6 103.2 66.8 0 66.8 74.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#335f8a",
    d: "m41.6 197c0.9 0.4 1.9 0.8 2.8 1.2-0.9-0.4-1.8-0.8-2.8-1.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#335f8a",
    d: "m44.4 198.1c0.9 0.4 1.9 0.7 2.9 1-1-0.3-1.9-0.6-2.9-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#335f8a",
    d: "m49.8 199.9c0.8 0.2 1.5 0.4 2.2 0.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6db2d8",
    d: "m1.9 116.3 64.9 38.4c-0.9 5.8-2.4 11.5-4.7 17-5.2 12.6-15.7 25.8-36 15.7-16.5-13.5-26.1-33.7-26.2-55 0-5.4 0.7-10.8 2-16.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#529bba",
    d: "m107.3 187.5c-0.4 0.3 0 0-1.3 1.1l-1.5 1-1.1 0.8c1.1-0.8-0.9 0.6-1.3 0.9-0.4 0.2-0.7 0.4-1.1 0.7l-0.7 0.5c-0.2 0.1-0.5 0.3-0.7 0.5 0 0-0.3 0.3-0.4 0.3 0.4-0.3-0.5 0.2-0.9 0.5-0.5 0.2-0.9 0.4-1.3 0.7l-2 1c-0.4 0.2-0.2 0-0.6 0.3s-0.9 0.4-1.4 0.7 0 0-1.7 0.8c1.7-0.8 0 0-0.9 0.4 0.9-0.4-1.6 0.6-2.7 1-0.4 0.1-2.6 0.8-3 0.9s-0.9 0.3-1.3 0.4c-0.8 0.2-1.5 0.4-2.2 0.6-0.3 0.1-0.6 0.1-0.8 0.2l-0.5 0.1-1.2 0.3c-0.4 0.1-0.7 0.1-1.1 0.2s-0.7 0.1-1 0.2-0.8 0.1-1.1 0.2c-0.2 0-0.4 0-0.5 0.1l-0.8 0.1h-0.4c-0.3 0-0.6 0.1-0.9 0.1s-0.8 0.1-1.2 0.1h-10.2c-0.4 0-0.8-0.1-1.2-0.1-0.3 0-0.6 0-0.9-0.1h-0.4c-0.3 0-0.6-0.1-0.8-0.1s-0.4 0-0.5-0.1c-0.4 0-0.7-0.1-1.1-0.2-0.3 0-0.7-0.1-1-0.2s-0.7-0.1-1.1-0.2l-1.2-0.3-0.5-0.1c-0.3 0-0.6-0.1-0.8-0.2-0.8-0.2-1.5-0.4-2.2-0.6l-1.3-0.4c-0.4-0.1-0.8-0.2-1.2-0.4-1-0.3-1.9-0.7-2.9-1s-1.9-0.8-2.8-1.2c-0.4-0.2-0.9-0.4-1.4-0.6s-1-0.4-1.4-0.7c-0.5-0.2-0.9-0.4-1.3-0.7-0.4-0.2-0.9-0.5-1.3-0.7s-0.7-0.4-1-0.6c-1-0.6-1.6-1-1-0.6l-0.6-0.4-1.1-0.7-0.4-0.2-1-0.7c-0.4-0.3-0.8-0.5-1.2-0.8s-0.9-0.6-1.3-0.9-0.8-0.7-1.1-0.9l-0.4-0.3c-0.4-0.2-0.7-0.5-1-0.8 20.3 10.1 30.7-3.3 35.9-15.8 2.2-5.5 3.8-11.2 4.7-17 0.9 5.9 2.4 11.7 4.7 17.2 5.4 12.4 15.6 25.7 35.9 15.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#335f8a",
    d: "m81.6 200.5c0.8-0.2 1.5-0.4 2.2-0.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#335f8a",
    d: "m86.3 199.1c1-0.3 1.9-0.6 2.9-1-1 0.4-1.9 0.7-2.9 1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#335f8a",
    d: "m89 198.2c0.9-0.4 2.1-0.8 3-1.3-1 0.5-2.1 0.9-3 1.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b6b9a",
    d: "m133.7 132.5c-0.1 21.3-9.7 41.4-26.2 54.9-20.3 10.1-30.8-3.2-36-15.7-2.2-5.5-3.8-11.2-4.7-17l64.9-38.4c1.3 5.3 2 10.7 2 16.2z"
  })))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "rotate",
    viewBox: "0 0 55 50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.49 20.5-0.988 0.988 5 5a0.7 0.7 0 0 0 0.988 0l5-5-0.988-0.988-4.51 4.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 0.301c-13.6 0-24.7 11.1-24.7 24.7a0.7 0.7 0 0 0 0.699 0.699 0.7 0.7 0 0 0 0.699-0.699c0-12.9 10.4-23.3 23.3-23.3s23.3 10.4 23.3 23.3-10.4 23.3-23.3 23.3a0.7 0.7 0 0 0-0.699 0.699 0.7 0.7 0 0 0 0.699 0.699c13.6 0 24.7-11.1 24.7-24.7s-11.1-24.7-24.7-24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 18.3c-3.69 0-6.7 3.01-6.7 6.7s3.01 6.7 6.7 6.7 6.7-3.01 6.7-6.7-3.01-6.7-6.7-6.7zm0 1.4c2.94 0 5.3 2.37 5.3 5.3s-2.37 5.3-5.3 5.3-5.3-2.37-5.3-5.3 2.37-5.3 5.3-5.3z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "shield-check",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 34L12 26L14.82 23.18L20 28.34L33.18 15.16L36 18L20 34ZM24 2L6 10V22C6 33.1 13.68 43.48 24 46C34.32 43.48 42 33.1 42 22V10L24 2Z",
    fill: "white"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "swap",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 8L15 12H18C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C11 18 10.03 17.75 9.2 17.3L7.74 18.76C8.97 19.54 10.43 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12H23L19 8ZM6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13 6 13.97 6.25 14.8 6.7L16.26 5.24C15.03 4.46 13.57 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12H1L5 16L9 12"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "tether"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.922 17.383v-.002c-.11.008-.677.042-1.942.042-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658 0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061 1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658 0 .81-2.895 1.485-6.775 1.657m0-3.59v-2.366h5.414V7.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118 0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116 0-1.043-3.301-1.914-7.694-2.117"
  })))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash-can",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 5H15.5L14.5 4H9.5L8.5 5H5V7H19V5ZM6 17C6 17.5304 6.21071 18.0391 6.58579 18.4142C6.96086 18.7893 7.46957 19 8 19H16C16.5304 19 17.0391 18.7893 17.4142 18.4142C17.7893 18.0391 18 17.5304 18 17V8H6V17Z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 20 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2721 0.58667H18.0833L11.9416 7.60625L19.1668 17.1583H13.5095L9.07852 11.365L4.00845 17.1583H1.19552L7.76469 9.65008L0.833496 0.58667H6.63442L10.6397 5.88195L15.2721 0.58667ZM14.2854 15.4757H15.8432L5.78799 2.18095H4.11638L14.2854 15.4757Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "uniswap",
    viewBox: "0 0 14 15"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(240)",
    d: "m-2.4952 2.3122a7.5 7.5 0 0 1-7.4999 7.5 7.5 7.5 0 0 1-7.5001-7.4997 7.5 7.5 0 0 1 7.4996-7.5003 7.5 7.5 0 0 1 7.5004 7.4995l-7.5 5.018e-4z",
    fill: "#fff",
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 .9 .9949 .60518)",
    fill: "#ff017a",
    style: {
      mixBlendMode: "darken"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m4.1522 1.5514c-0.18805-0.02899-0.19598-0.03239-0.10749-0.04591 0.16959-0.02592 0.57004 0.00941 0.84599 0.07462 0.64422 0.1522 1.2304 0.54209 1.8562 1.2345l0.16624 0.18396 0.23781-0.038c1.0019-0.16002 2.0211-0.03284 2.8735 0.35856 0.2345 0.10768 0.6043 0.32203 0.6505 0.37711 0.0147 0.01755 0.0417 0.13055 0.06 0.25113 0.0633 0.41716 0.0316 0.73692-0.0967 0.97575-0.0699 0.12996-0.0738 0.17115-0.0268 0.28237 0.0375 0.08876 0.142 0.15445 0.2455 0.15431 0.2118-2.9e-4 0.4398-0.34065 0.5455-0.81424l0.042-0.18811 0.0831 0.09359c0.456 0.5135 0.8142 1.2138 0.8757 1.7123l0.016 0.12997-0.0766-0.11815c-0.1319-0.20331-0.2645-0.34171-0.4342-0.45334-0.306-0.20121-0.6295-0.26968-1.4862-0.31456-0.77381-0.04052-1.2118-0.10621-1.646-0.24695-0.73883-0.23942-1.1113-0.55828-1.9889-1.7027-0.38981-0.50832-0.63075-0.78956-0.87042-1.016-0.54459-0.51464-1.0797-0.78454-1.7647-0.89014z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m10.849 2.6864c0.0195-0.34062 0.0659-0.56529 0.1594-0.77047 0.037-0.08121 0.0716-0.14768 0.077-0.14768 0.0053 0-0.0108 0.05994-0.0358 0.1332-0.0679 0.19912-0.0791 0.47148-0.0323 0.78836 0.0594 0.40206 0.0932 0.46007 0.5208 0.89438 0.2005 0.20372 0.4338 0.46064 0.5183 0.57095l0.1538 0.20057-0.1538-0.14334c-0.188-0.17529-0.6204-0.51714-0.7159-0.56601-0.0641-0.03277-0.0736-0.0322-0.1131 0.00688-0.0364 0.03601-0.0441 0.09012-0.0491 0.34594-0.0079 0.39871-0.0626 0.65462-0.1945 0.9105-0.0714 0.1384-0.0827 0.10886-0.0181-0.04735 0.0482-0.11664 0.0531-0.16791 0.0528-0.55388-8e-4 -0.77551-0.0934-0.96195-0.6366-1.2813-0.1376-0.08091-0.3644-0.19759-0.50391-0.25931-0.13952-0.06172-0.25034-0.11548-0.24631-0.1195 0.01538-0.01521 0.54512 0.13847 0.75842 0.22 0.3172 0.12126 0.3695 0.13698 0.408 0.12235 0.0259-0.00981 0.0384-0.08455 0.0509-0.30426z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m4.5174 4.013c-0.38176-0.52238-0.61797-1.3233-0.56683-1.922l0.01581-0.18528 0.0869 0.01576c0.16319 0.02958 0.44456 0.13367 0.57631 0.21321 0.36156 0.21824 0.51809 0.50558 0.67733 1.2434 0.04665 0.21612 0.10785 0.46069 0.13601 0.54349 0.04533 0.13327 0.21664 0.44457 0.35592 0.64674 0.10032 0.14561 0.03368 0.21461-0.18808 0.19471-0.33867-0.03038-0.79742-0.34506-1.0934-0.75001z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m10.386 7.9009c-1.7841-0.71395-2.4124-1.3337-2.4124-2.3793 0-0.15388 0.00533-0.27978 0.01182-0.27978 0.0065 0 0.07553 0.05078 0.15339 0.11286 0.36178 0.2884 0.7669 0.41158 1.8884 0.5742 0.66 0.0957 1.0314 0.173 1.374 0.28592 1.0889 0.35894 1.7626 1.0874 1.9233 2.0795 0.0467 0.28829 0.0193 0.82891-0.0564 1.1138-0.0597 0.22505-0.2421 0.6307-0.2905 0.6463-0.0134 0.0043-0.0265-0.0468-0.03-0.11631-0.0183-0.37255-0.2077-0.73524-0.5258-1.0069-0.3617-0.30889-0.8476-0.55483-2.0358-1.0303z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m9.1338 8.1975c-0.02236-0.13221-0.06113-0.30105-0.08616-0.3752l-0.04552-0.1348 0.08455 0.09432c0.11702 0.13054 0.20948 0.29757 0.28785 0.52005 0.05981 0.1698 0.06654 0.2203 0.06609 0.49622-4.6e-4 0.27089-0.00793 0.32768-0.06316 0.48052-0.08708 0.241-0.19517 0.41189-0.37653 0.59532-0.3259 0.32969-0.7449 0.51219-1.3495 0.58789-0.1051 0.0131-0.41143 0.0353-0.68074 0.0492-0.67869 0.0351-1.1254 0.1076-1.5268 0.2477-0.0577 0.0201-0.10923 0.0324-0.11446 0.0272-0.01624-0.0161 0.25704-0.178 0.48276-0.2861 0.31827-0.1524 0.6351-0.2355 1.345-0.353 0.35066-0.0581 0.71279-0.1285 0.80475-0.15651 0.86839-0.26463 1.3148-0.94753 1.1719-1.7928z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m9.9517 9.6411c-0.23704-0.50646-0.29147-0.99545-0.16161-1.4515 0.01391-0.04873 0.03624-0.08861 0.04968-0.08861 0.01343 0 0.06937 0.03005 0.12428 0.06677 0.10926 0.07309 0.32836 0.19618 0.91196 0.51246 0.7283 0.39467 1.1436 0.70027 1.426 1.0494 0.2473 0.30575 0.4003 0.65405 0.474 1.0788 0.0417 0.2405 0.0172 0.8193-0.0449 1.0615-0.1958 0.7638-0.6509 1.3637-1.3 1.7138-0.0951 0.0513-0.1805 0.0934-0.1897 0.0936-0.0093 2e-4 0.0254-0.0874 0.077-0.1946 0.2183-0.4537 0.2432-0.895 0.0781-1.3862-0.1011-0.3008-0.3072-0.6678-0.7233-1.2881-0.4839-0.7211-0.6025-0.91301-0.72151-1.1673z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m3.2505 12.374c0.66206-0.5556 1.4858-0.9503 2.2362-1.0715 0.32339-0.0522 0.86211-0.0315 1.1616 0.0447 0.48001 0.1221 0.9094 0.3956 1.1327 0.7214 0.21824 0.3184 0.31187 0.5959 0.40935 1.2133 0.03846 0.2436 0.08028 0.4881 0.09294 0.5435 0.07321 0.32 0.21567 0.5757 0.39221 0.7042 0.28039 0.204 0.76321 0.2166 1.2382 0.0325 0.08061-0.0313 0.15058-0.0529 0.15548-0.048 0.0173 0.017-0.22191 0.1761-0.39063 0.2599-0.22704 0.1127-0.40757 0.1563-0.64745 0.1563-0.43501 0-0.79616-0.2199-1.0975-0.6684-0.05931-0.0883-0.1926-0.3526-0.29621-0.5875-0.31819-0.7213-0.4753-0.941-0.84474-1.1815-0.32151-0.2092-0.73614-0.2467-1.0481-0.0947-0.40974 0.1997-0.52406 0.7201-0.2306 1.0499 0.11664 0.1311 0.33414 0.2441 0.51199 0.2661 0.33273 0.0412 0.61867-0.2104 0.61867-0.5443 0-0.2168-0.08384-0.3405-0.29489-0.4352-0.28826-0.1293-0.5981 0.0219-0.59662 0.291 6.4e-4 0.1148 0.05092 0.1868 0.16667 0.2389 0.07426 0.0334 0.07598 0.036 0.01543 0.0235-0.26448-0.0545-0.32644-0.3714-0.11379-0.5818 0.25532-0.2525 0.78326-0.1411 0.96456 0.2037 0.07617 0.1448 0.085 0.4332 0.0186 0.6073-0.14861 0.3898-0.58195 0.5947-1.0215 0.4832-0.29929-0.076-0.42116-0.1582-0.782-0.5276-0.62702-0.642-0.87044-0.7664-1.7744-0.9066l-0.17322-0.0269z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m0.30838 0.88398c2.094 2.526 3.5362 3.5681 3.6965 3.7883 0.13233 0.18181 0.08253 0.34526-0.14417 0.47336-0.12607 0.07122-0.38526 0.14338-0.51503 0.14338-0.14677 0-0.19717-0.05627-0.19717-0.05627-0.0851-0.08023-0.13303-0.0662-0.57007-0.83723-0.60674-0.93574-1.1145-1.712-1.1284-1.725-0.03203-0.03005-0.03148-0.02904 1.0665 1.9236 0.1774 0.40697 0.03528 0.55636 0.03528 0.61432 0 0.11791-0.03236 0.17989-0.17871 0.34214-0.24397 0.27051-0.35303 0.57446-0.43176 1.2035-0.08825 0.70516-0.33643 1.2033-1.0242 2.0558-0.40259 0.49904-0.46847 0.59051-0.57006 0.79164-0.12796 0.25329-0.16314 0.39516-0.1774 0.71497-0.015072 0.3382 0.014282 0.5567 0.11823 0.88 0.091005 0.2831 0.186 0.47 0.42884 0.8438 0.20957 0.3226 0.33024 0.5624 0.33024 0.6562 0 0.0746 0.01434 0.0747 0.33909 0.0018 0.77717-0.1744 1.4082-0.4812 1.7631-0.8572 0.21966-0.2327 0.27123-0.3612 0.2729-0.68 0.0011-0.2086-0.00628-0.2523-0.06301-0.3723-0.09234-0.1953-0.26045-0.3577-0.63097-0.6094-0.48547-0.32987-0.69283-0.59542-0.7501-0.96062-0.04699-0.29965 0.00752-0.51107 0.27609-1.0705 0.27798-0.57909 0.34687-0.82586 0.39347-1.4096 0.0301-0.37711 0.07178-0.52583 0.18079-0.64521 0.1137-0.12448 0.21605-0.16664 0.49742-0.20485 0.45873-0.06228 0.75083-0.18024 0.99093-0.40014 0.20828-0.19077 0.29544-0.37458 0.30881-0.65129l0.01016-0.20973-0.1164-0.13488c-0.42151-0.48848-4.4932-3.9926-4.5192-3.9926-0.0055415 0 0.13316 0.1728 0.30822 0.38398zm0.97526 9.8152c0.0953-0.1678 0.04466-0.3834-0.11475-0.4888-0.15062-0.0995-0.38461-0.0526-0.38461 0.0771 0 0.0396 0.022023 0.0684 0.071657 0.0938 0.083577 0.0427 0.089644 0.0908 0.023886 0.189-0.066593 0.0995-0.061219 0.187 0.015168 0.2464 0.12311 0.0958 0.29738 0.0431 0.38865-0.1175z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m4.9252 5.9986c-0.21535 0.06574-0.42469 0.29259-0.48949 0.53045-0.03953 0.14511-0.0171 0.39965 0.04211 0.47826 0.09566 0.12697 0.18817 0.16042 0.43866 0.15867 0.49042-0.0034 0.91676-0.21245 0.96633-0.47379 0.04063-0.21423-0.14662-0.51112-0.40454-0.64146-0.13309-0.06723-0.41613-0.0939-0.55307-0.05213zm0.5733 0.44557c0.07563-0.10681 0.04254-0.22224-0.08608-0.30031-0.24495-0.14866-0.61537-0.02564-0.61537 0.20435 0 0.11448 0.19317 0.23939 0.37023 0.23939 0.11785 0 0.27913-0.06985 0.33122-0.14343z",
    clipRule: "evenodd"
  })))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "usdc",
    viewBox: "0 0 8.4667 8.4667"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 4.1,
    r: 4,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.0972 0.0075104c-0.10009 0.01313-0.20387 0.01032-0.30476 0.02007-0.22503 0.02176-0.45053 0.06359-0.66878 0.1226-0.99651 0.2694-1.8836 0.90716-2.4436 1.776-0.23891 0.37069-0.42038 0.77563-0.53562 1.2014-0.36423 1.3456-0.02913 2.8352 0.88946 3.8875 0.26901 0.30817 0.58282 0.58046 0.93001 0.79773 0.39 0.24399 0.81733 0.42906 1.2656 0.53528 0.5088 0.12052 1.0394 0.15102 1.5577 0.0829 0.48635-0.0639 0.96085-0.21071 1.3968-0.43563 1.3585-0.70073 2.2441-2.1253 2.2814-3.6496 0.0356-1.4539-0.69287-2.8694-1.9216-3.6604-0.35653-0.22949-0.74354-0.4046-1.1513-0.52079-0.29778-0.08485-0.60203-0.1298-0.91005-0.15088-0.12402-0.0085-0.26129-0.02254-0.38519-0.0063m-0.8 1.2347c0.05556-0.0087 0.11016 0.02218 0.13071 0.07486 0.01525 0.03908 9e-3 0.08577 9e-3 0.1269 0 0.10344 0.03103 0.25807-0.05928 0.3322-0.03637 0.02986-0.08392 0.04315-0.12697 0.06036-0.06033 0.02412-0.11917 0.0511-0.17778 0.07904-0.16854 0.08037-0.32755 0.18388-0.47408 0.29918-0.65758 0.51742-1.056 1.377-0.99856 2.2157 0.0526 0.76756 0.4265 1.4822 1.0409 1.9506 0.13758 0.10487 0.28792 0.19725 0.44444 0.27115 0.0834 0.0394 0.19951 0.0635 0.27088 0.12094 0.02988 0.0241 0.05706 0.0581 0.07158 0.0939 0.0148 0.0365 0.0089 0.0799 0.0089 0.11845 0 0.0963 0.03465 0.28439-0.08466 0.32526-0.05512 0.0189-0.12262-0.0168-0.17354-0.0358-0.13274-0.0496-0.26255-0.10233-0.38942-0.1657-0.59221-0.29594-1.0465-0.77019-1.369-1.342-0.10896-0.1932-0.1904-0.40856-0.24974-0.62184-0.25804-0.9275-0.08848-1.9345 0.47344-2.72 0.17252-0.24116 0.37978-0.45479 0.61195-0.63877 0.22985-0.18214 0.4868-0.32827 0.75767-0.43997 0.06819-0.02812 0.13744-0.05277 0.20741-0.0761 0.02519-0.0084 0.05002-0.02424 0.07619-0.02833m1.8243 0.0043c0.0488-0.0087 0.0946 0.01456 0.13969 0.02963 0.10112 0.03381 0.19945 0.07564 0.29629 0.11996 0.41931 0.19186 0.79205 0.47728 1.0926 0.82619 0.84622 0.98232 1.0042 2.4436 0.38756 3.583-0.15577 0.28786-0.35471 0.55242-0.59129 0.77852-0.27657 0.2643-0.59598 0.4775-0.94815 0.62767-0.082 0.035-0.16516 0.066-0.24973 0.0941-0.0382 0.0127-0.0728 0.034-0.11429 0.0306-0.0533-4e-3 -0.0947-0.0505-0.10387-0.10114-8e-3 -0.0431-2e-3 -0.0916-2e-3 -0.13537 0-0.10706-0.0273-0.24793 0.0804-0.31333 0.0527-0.0321 0.117-0.0489 0.17355-0.0734 0.0942-0.0408 0.18637-0.0881 0.27513-0.1396 0.3418-0.19827 0.63107-0.47302 0.8549-0.79772 0.69055-1.0017 0.57084-2.3932-0.25422-3.2784-0.20173-0.21645-0.44072-0.39602-0.70226-0.53393-0.10295-0.05429-0.21249-0.09062-0.31747-0.13946-0.14861-0.06915-0.11005-0.27405-0.11005-0.4053 0-0.0636 0.0153-0.15812 0.0931-0.17205m-0.60529 4.5926v0.3088c0 0.0643 6e-3 0.12801-0.0268 0.18613-0.0175 0.0306-0.0446 0.0545-0.079 0.0643-0.039 0.0112-0.0827 8e-3 -0.12275 8e-3 -0.09524 0-0.23152 0.0228-0.29536-0.0677-0.02722-0.0386-0.0221-0.0821-0.0221-0.12687v-0.24112c0-0.0287 0.01317-0.10262-0.0068-0.12474-0.0185-0.0205-0.07706-0.0193-0.10327-0.0251-0.08543-0.0189-0.16874-0.0439-0.24974-0.0769-0.25134-0.10259-0.45771-0.30965-0.53513-0.57277-0.02001-0.068-0.0537-0.15224-0.03834-0.2242 0.02942-0.13782 0.25032-0.0931 0.35336-0.0931 0.04734 0 0.09965-7e-3 0.13967 0.0234 0.05272 0.0407 0.05464 0.11261 0.07415 0.17119 0.02623 0.0787 0.06795 0.15403 0.12904 0.21113 0.07553 0.0707 0.171 0.1113 0.2709 0.1333 0.27738 0.0612 0.67044 0.0211 0.79386-0.28097 0.0787-0.19256 0.0254-0.41261-0.16317-0.51477-0.41513-0.22492-0.96502-0.0893-1.3291-0.43719-0.25001-0.2389-0.28755-0.67861-0.12568-0.97701 0.11479-0.21161 0.31534-0.35373 0.54049-0.42866 0.07165-0.02385 0.15261-0.04779 0.22857-0.04935v-0.29611c0-0.06533-0.0051-0.12743 0.02911-0.18613 0.01795-0.03078 0.04605-0.05393 0.08094-0.06244 0.03816-0.0093 0.07952-0.0052 0.11852-0.0052 0.09413 0 0.23416-0.02399 0.29587 0.0677 0.027 0.04015 0.0216 0.08506 0.0216 0.13112v0.23266c0 0.02798-0.0137 0.10799 7e-3 0.12858 0.0166 0.01674 0.0679 0.01427 0.0906 0.01864 0.0654 0.01261 0.12961 0.03238 0.19048 0.05947 0.20647 0.0919 0.3655 0.259 0.45409 0.46591 0.0281 0.0657 0.0676 0.16031 0.05 0.23266-9e-3 0.03657-0.0327 0.06808-0.0682 0.08257-0.0358 0.01461-0.0766 0.0105-0.11429 0.0105-0.0867 0-0.2157 0.02421-0.29206-0.02313-0.0481-0.02986-0.0583-0.08933-0.0798-0.13762-0.0292-0.06552-0.0719-0.12925-0.12758-0.17507-0.0508-0.0418-0.10684-0.07005-0.16931-0.08998-0.25228-0.08048-0.68618-0.04808-0.76973 0.25659-0.05725 0.20874 0.03232 0.40028 0.23216 0.48283 0.15974 0.06598 0.33432 0.08192 0.50371 0.10631 0.26861 0.03868 0.56944 0.10013 0.7746 0.29112 0.31022 0.2888 0.27793 0.84803 0.0311 1.1629-0.16301 0.20792-0.4301 0.34755-0.69139 0.38072z",
    fill: "#2775c9"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "dai",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 444.44 444.44"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5AC37",
    fillRule: "nonzero",
    d: "M222.22 0c122.74,0 222.22,99.5 222.22,222.22 0,122.74 -99.48,222.22 -222.22,222.22 -122.72,0 -222.22,-99.49 -222.22,-222.22 0,-122.72 99.5,-222.22 222.22,-222.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFD",
    fillRule: "nonzero",
    d: "M230.41 237.91l84.44 0c1.8,0 2.65,0 2.78,-2.36 0.69,-8.59 0.69,-17.23 0,-25.83 0,-1.67 -0.83,-2.36 -2.64,-2.36l-168.05 0c-2.08,0 -2.64,0.69 -2.64,2.64l0 24.72c0,3.19 0,3.19 3.33,3.19l82.78 0zm77.79 -59.44c0.24,-0.63 0.24,-1.32 0,-1.94 -1.41,-3.07 -3.08,-6 -5.02,-8.75 -2.92,-4.7 -6.36,-9.03 -10.28,-12.92 -1.85,-2.35 -3.99,-4.46 -6.39,-6.25 -12.02,-10.23 -26.31,-17.47 -41.67,-21.11 -7.75,-1.74 -15.67,-2.57 -23.61,-2.5l-74.58 0c-2.08,0 -2.36,0.83 -2.36,2.64l0 49.3c0,2.08 0,2.64 2.64,2.64l160.27 0c0,0 1.39,-0.28 1.67,-1.11l-0.68 0zm0 88.33c-2.36,-0.26 -4.74,-0.26 -7.1,0l-154.02 0c-2.08,0 -2.78,0 -2.78,2.78l0 48.2c0,2.22 0,2.78 2.78,2.78l71.11 0c3.4,0.26 6.8,0.02 10.13,-0.69 10.32,-0.74 20.47,-2.98 30.15,-6.67 3.52,-1.22 6.92,-2.81 10.13,-4.72l0.97 0c16.67,-8.67 30.21,-22.29 38.75,-39.01 0,0 0.97,-2.1 -0.12,-2.65zm-191.81 78.75l0 -0.83 0 -32.36 0 -10.97 0 -32.64c0,-1.81 0,-2.08 -2.22,-2.08l-30.14 0c-1.67,0 -2.36,0 -2.36,-2.22l0 -26.39 32.22 0c1.8,0 2.5,0 2.5,-2.36l0 -26.11c0,-1.67 0,-2.08 -2.22,-2.08l-30.14 0c-1.67,0 -2.36,0 -2.36,-2.22l0 -24.44c0,-1.53 0,-1.94 2.22,-1.94l29.86 0c2.08,0 2.64,0 2.64,-2.64l0 -74.86c0,-2.22 0,-2.78 2.78,-2.78l104.16 0c7.56,0.3 15.07,1.13 22.5,2.5 15.31,2.83 30.02,8.3 43.47,16.11 8.92,5.25 17.13,11.59 24.44,18.89 5.5,5.71 10.46,11.89 14.86,18.47 4.37,6.67 8,13.8 10.85,21.25 0.35,1.94 2.21,3.25 4.15,2.92l24.86 0c3.19,0 3.19,0 3.33,3.06l0 22.78c0,2.22 -0.83,2.78 -3.06,2.78l-19.17 0c-1.94,0 -2.5,0 -2.36,2.5 0.76,8.46 0.76,16.95 0,25.41 0,2.36 0,2.64 2.65,2.64l21.93 0c0.97,1.25 0,2.5 0,3.76 0.14,1.61 0.14,3.24 0,4.85l0 16.81c0,2.36 -0.69,3.06 -2.78,3.06l-26.25 0c-1.83,-0.35 -3.61,0.82 -4.03,2.64 -6.25,16.25 -16.25,30.82 -29.17,42.5 -4.72,4.25 -9.68,8.25 -14.86,11.94 -5.56,3.2 -10.97,6.53 -16.67,9.17 -10.49,4.72 -21.49,8.2 -32.78,10.41 -10.72,1.92 -21.59,2.79 -32.5,2.64l-96.39 0 0 -0.14z"
  })))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "usdt",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#26a69a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 5,
    x: 15,
    y: 13,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,21c-4.457,0-12,0.737-12,3.5S19.543,28,24,28s12-0.737,12-3.5S28.457,21,24,21z M24,26 c-5.523,0-10-0.895-10-2c0-1.105,4.477-2,10-2s10,0.895,10,2C34,25.105,29.523,26,24,26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,24c1.095,0,2.093-0.037,3-0.098V13h-6v10.902C21.907,23.963,22.905,24,24,24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.723,25.968c-0.111,0.004-0.223,0.007-0.336,0.01C24.932,25.991,24.472,26,24,26 s-0.932-0.009-1.387-0.021c-0.113-0.003-0.225-0.006-0.336-0.01c-0.435-0.015-0.863-0.034-1.277-0.06V36h6V25.908 C26.586,25.934,26.158,25.953,25.723,25.968z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "vechain"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#15BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M14.738 24.734L7.04 9.046a.38.38 0 0 1 .34-.546h2.668c.143 0 .277.08.34.206l5.622 11.381c.5 1.02 1.951 1.02 2.452 0l5.604-11.372a.382.382 0 0 1 .34-.206h.332c.197 0 .322.206.233.376l-7.78 15.85c-.501 1.02-1.951 1.02-2.453 0z"
  })))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "wallet",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 24V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.18667 28 4 26.8 4 25.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H25.3333C26.0406 4 26.7189 4.28095 27.219 4.78105C27.719 5.28115 28 5.95942 28 6.66667V8H16C14.52 8 13.3333 9.2 13.3333 10.6667V21.3333C13.3333 22.0406 13.6143 22.7189 14.1144 23.219C14.6145 23.719 15.2928 24 16 24H28ZM16 21.3333H29.3333V10.6667H16V21.3333ZM21.3333 18C20.8029 18 20.2942 17.7893 19.9191 17.4142C19.544 17.0391 19.3333 16.5304 19.3333 16C19.3333 15.4696 19.544 14.9609 19.9191 14.5858C20.2942 14.2107 20.8029 14 21.3333 14C21.8638 14 22.3725 14.2107 22.7475 14.5858C23.1226 14.9609 23.3333 15.4696 23.3333 16C23.3333 16.5304 23.1226 17.0391 22.7475 17.4142C22.3725 17.7893 21.8638 18 21.3333 18Z",
    fill: "#848498"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "walletconnect",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.10605 0 0 .10605 -.004008 5.9285)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    transform: "translate(.94295)",
    fill: "#3b99fc",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m61.439 36.256c48.911-47.888 128.21-47.888 177.12 0l5.8866 5.7634c2.4456 2.3944 2.4456 6.2765 0 8.6709l-20.137 19.716c-1.2228 1.1972-3.2053 1.1972-4.4281 0l-8.1006-7.9311c-34.122-33.408-89.444-33.408-123.57 0l-8.6751 8.4936c-1.2228 1.1972-3.2053 1.1972-4.4281 0l-20.137-19.716c-2.4456-2.3944-2.4456-6.2765 0-8.6709zm218.77 40.774 17.922 17.547c2.4455 2.3944 2.4456 6.2765 3e-5 8.6709l-80.81 79.121c-2.4456 2.3944-6.4106 2.3944-8.8562 6e-5 -1e-5 -1e-5 -3e-5 -2e-5 -4e-5 -3e-5l-57.354-56.155c-0.61139-0.5986-1.6026-0.5986-2.214 0 0 1e-5 -1e-5 1e-5 -1e-5 2e-5l-57.353 56.155c-2.4455 2.3944-6.4106 2.3945-8.8562 8e-5 -1.5e-5 -1e-5 -3e-5 -2e-5 -4.5e-5 -4e-5l-80.812-79.122c-2.4456-2.3944-2.4456-6.2765 0-8.6709l17.922-17.547c2.4456-2.3944 6.4106-2.3944 8.8562 0l57.355 56.155c0.61139 0.59861 1.6026 0.59861 2.214 0 1e-5 0 1.8e-5 -1e-5 2.7e-5 -2e-5l57.352-56.155c2.4455-2.3945 6.4105-2.3946 8.8562-2e-4 3e-5 3.4e-5 7e-5 6.7e-5 1e-4 1.01e-4l57.355 56.155c0.61139 0.5986 1.6026 0.5986 2.214 0l57.354-56.154c2.4456-2.3944 6.4106-2.3944 8.8562 0z"
  }))))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "walletlink",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 16a16 16 0 0 1-16 16 16 16 0 0 1-16-16 16 16 0 0 1 16-16 16 16 0 0 1 16 16z",
    fill: "#0052ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.094 25.336c-1.8048-0.22979-3.3119-0.81456-4.6632-1.8094-1.8521-1.3635-3.1316-3.3776-3.6297-5.7141-0.16158-0.75783-0.16158-2.8672 0-3.625 0.82286-3.8592 3.6767-6.6537 7.5742-7.4166 0.77291-0.15129 2.4609-0.15029 3.2771 0.00193 3.8161 0.7117 6.7279 3.5724 7.5471 7.4146 0.16158 0.75783 0.16158 2.8672 0 3.625-0.81009 3.7993-3.6351 6.6104-7.418 7.3815-0.57931 0.11808-2.202 0.20382-2.6875 0.142zm3.7021-6.5184 0.20411-0.18237v-5.2705l-0.40822-0.36475h-5.1836l-0.40822 0.36475v5.2705l0.40822 0.36475h5.1836z",
    fill: "#fff"
  })))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "wbtc"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M23.189 14.02c.314-2.096-1.283-3.223-3.465-3.975l.708-2.84-1.728-.43-.69 2.765c-.454-.114-.92-.22-1.385-.326l.695-2.783L15.596 6l-.708 2.839c-.376-.086-.746-.17-1.104-.26l.002-.009-2.384-.595-.46 1.846s1.283.294 1.256.312c.7.175.826.638.805 1.006l-.806 3.235c.048.012.11.03.18.057l-.183-.045-1.13 4.532c-.086.212-.303.531-.793.41.018.025-1.256-.313-1.256-.313l-.858 1.978 2.25.561c.418.105.828.215 1.231.318l-.715 2.872 1.727.43.708-2.84c.472.127.93.245 1.378.357l-.706 2.828 1.728.43.715-2.866c2.948.558 5.164.333 6.097-2.333.752-2.146-.037-3.385-1.588-4.192 1.13-.26 1.98-1.003 2.207-2.538zm-3.95 5.538c-.533 2.147-4.148.986-5.32.695l.95-3.805c1.172.293 4.929.872 4.37 3.11zm.535-5.569c-.487 1.953-3.495.96-4.47.717l.86-3.45c.975.243 4.118.696 3.61 2.733z"
  })))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "tbtc",
    viewBox: "0 0 144 144",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.85 143.7C111.532 143.7 143.7 111.532 143.7 71.85C143.7 32.1683 111.532 0 71.85 0C32.1683 0 0 32.1683 0 71.85C0 111.532 32.1683 143.7 71.85 143.7Z",
    fill: "#1D2229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5621 65.1122H47.531V77.1433H59.5621V65.1122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5309 53.081H35.4997V65.1121L47.531 65.1122L47.5309 53.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4978 65.1122H23.4667V77.1433H35.4978V65.1122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.531 77.1433L35.4997 77.1427V89.1738H47.5309L47.531 77.1433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.922 55.6723C115.074 46.824 107.437 43.8538 97.791 43.0056V37.3377H90.3225V42.6822C88.3601 42.6822 86.3535 42.7198 84.3579 42.7575V37.3333H76.8938V42.9989C75.2769 43.0299 65.3433 43.0211 65.3433 43.0211L65.3211 49.6058L71.5538 49.6413V92.7977H65.3233L65.268 99.2895C67.0775 99.2895 75.1308 99.3249 76.8761 99.336V104.931H84.3401V99.4689C86.3867 99.5132 88.3712 99.5309 90.307 99.5287V104.933H97.7777V99.3626C110.338 98.6472 119.133 95.4866 120.225 83.6947C121.111 74.1974 116.646 69.9626 109.516 68.2394C113.849 66.0246 116.558 62.1463 115.926 55.6701L115.922 55.6723ZM105.457 82.2129C105.457 91.491 89.5739 90.4301 84.5063 90.4323V73.9847C89.5716 73.9847 105.448 72.5384 105.45 82.2129H105.457ZM101.99 59.0057C101.99 67.4465 88.7366 66.4565 84.5173 66.4565V51.5372C88.7433 51.5394 101.995 50.2016 101.99 59.0057Z",
    fill: "white"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "weth",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#f6f6f6",
    fillRule: "evenodd",
    strokeWidth: 0.82129
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.067161 0 0 .067161 7.4035 2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 287.96 255.92 212.32 127.96 0 125.17 9.5 125.17 285.17",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 0 0 212.32 127.96 287.96 127.96 154.16",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 416.91 256 236.59 127.96 312.19 126.39 314.11 126.39 412.31",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 236.59 127.96 416.91 127.96 312.19",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 154.16 127.96 287.96 255.92 212.32",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 154.16 9e-4 212.32 127.96 287.96",
    fill: "#393939"
  })))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "eth",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.602,
    d: "M16.498 4v8.87l7.497 3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.498 4L9 16.22l7.498-3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.602,
    d: "M16.498 21.968v6.027L24 17.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.498 27.995v-6.028L9 17.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M16.498 20.573l7.497-4.353-7.497-3.348z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.602,
    d: "M9 16.22l7.498 4.353v-7.701z"
  }))))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "mETH",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#f6f6f6",
    fillRule: "evenodd",
    strokeWidth: 0.82129
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.067161 0 0 .067161 7.4035 2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 287.96 255.92 212.32 127.96 0 125.17 9.5 125.17 285.17",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 0 0 212.32 127.96 287.96 127.96 154.16",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 416.91 256 236.59 127.96 312.19 126.39 314.11 126.39 412.31",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 236.59 127.96 416.91 127.96 312.19",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 154.16 127.96 287.96 255.92 212.32",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.96 154.16 9e-4 212.32 127.96 287.96",
    fill: "#393939"
  })))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "wsteth",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 256,
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M361.012 237.812L363.878 242.209C396.204 291.798 388.984 356.742 346.52 398.348C321.539 422.826 288.798 435.066 256.056 435.069C256.056 435.069 256.056 435.069 361.012 237.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M256.044 297.764L361 237.812C256.045 435.069 256.044 435.069 256.044 435.069C256.044 392.108 256.044 342.88 256.044 297.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.988 237.812L148.122 242.209C115.796 291.798 123.016 356.742 165.48 398.348C190.461 422.826 223.202 435.066 255.944 435.069C255.944 435.069 255.944 435.069 150.988 237.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M255.914 297.764L150.958 237.812C255.914 435.069 255.914 435.069 255.914 435.069C255.914 392.108 255.914 342.88 255.914 297.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M256.083 163.833V267.233L346.491 215.566L256.083 163.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M256.056 163.833L165.583 215.565L256.056 267.233V163.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.056 76.875L165.583 215.599L256.056 163.722V76.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M256.083 163.706L346.56 215.585L256.083 76.7916V163.706Z",
    fill: "white"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "steth",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7959 18.5791L11.572 18.9226C9.04657 22.7968 9.61063 27.8705 12.9281 31.121C14.8798 33.0333 17.4377 33.9896 19.9956 33.9898C19.9956 33.9898 19.9956 33.9898 11.7959 18.5791Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.9927 23.2629L11.793 18.5791C19.9927 33.9898 19.9927 33.9898 19.9927 33.9898C19.9927 30.6335 19.9927 26.7875 19.9927 23.2629Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.2036 18.5791L28.4275 18.9226C30.953 22.7968 30.3889 27.8705 27.0714 31.121C25.1198 33.0333 22.5619 33.9896 20.0039 33.9898C20.0039 33.9898 20.0039 33.9898 28.2036 18.5791Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.0039 23.2629L28.2036 18.5791C20.004 33.9898 20.0039 33.9898 20.0039 33.9898C20.0039 30.6335 20.0039 26.7875 20.0039 23.2629Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.0059 12.7998V20.8779L27.069 16.8415L20.0059 12.7998Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.0038 12.7998L12.9355 16.8414L20.0038 20.8779V12.7998Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0038 6.00586L12.9355 16.8437L20.0038 12.7908V6.00586Z",
    fill: "#00A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.0059 12.7892L27.0744 16.8423L20.0059 5.99902V12.7892Z",
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }))))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "lusd",
    viewBox: "0 0 256 256"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs13"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    x: 0,
    id: "rect10",
    height: 128,
    width: 128
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0002549,0,0,2.0002549,2.0116637e-6,-0.40143488)",
    clipPath: "url(#b)",
    id: "a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g23",
    transform: "translate(0,-0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fill: "#745ddf",
    transform: "translate(23.721,0.614)",
    d: "M 101.714,81.709 A 63.907,63.907 0 0 1 51.675,126.8 V 108.588 A 30.378,30.378 0 0 0 63.039,100.96 29.384,29.384 0 0 0 67.5,94.7 29.685,29.685 0 0 0 70.96,80.637 C 70.96,64.537 59.337,58.1 48.44,53.326 l -5.518,-2.439 c -5.9,-2.646 -10.413,-5 -10.413,-9.029 0,-5.569 4.86,-8.562 9.444,-8.562 4.878,0 7.645,1.8 10.568,6.867 l 2.266,3.926 14.581,-9.357 -1.9,-3.528 A 28.319,28.319 0 0 0 51.676,17.604 V 0.9 c 1.418,0.242 2.819,0.553 4.238,0.917 0.138,0.035 0.294,0.069 0.45,0.1 a 3.682,3.682 0 0 1 0.467,0.121 0.535,0.535 0 0 1 0.138,0.035 c 0.381,0.1 0.778,0.19 1.176,0.311 a 63.992,63.992 0 0 1 43.569,79.325 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fill: "#2eb6ea",
    transform: "translate(0,0.162)",
    d: "m 76.779,81.972 c 0,7.334 -6.625,11.865 -12.748,11.865 -7.351,0 -11.554,-6.071 -12.367,-11.71 L 50.972,77.232 33.33,82.2 l 0.8,3.944 c 2.525,12.436 11.018,21.379 22.555,24.077 v 17.625 a 64.405,64.405 0 0 1 -9.271,-1.782 c -0.432,-0.1 -0.848,-0.225 -1.28,-0.346 A 64.037,64.037 0 0 1 0,64.295 V 2.805 A 2.528,2.528 0 0 1 2.525,0.28 h 54.156 v 17.608 a 25.936,25.936 0 0 0 -15.1,11.692 24.69,24.69 0 0 0 -3.252,12.4 v 0.346 C 38.5,56.684 49.053,62.686 59.016,67.2 l 4.984,2.162 0.415,0.19 c 7.902,3.616 12.364,5.985 12.364,12.42 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g21",
    transform: "translate(33.33,0.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fill: "#ffffff",
    transform: "translate(-19.27,-0.392)",
    d: "m 80.621,81.251 a 29.685,29.685 0 0 1 -3.459,14.062 29.384,29.384 0 0 1 -4.463,6.261 30.378,30.378 0 0 1 -11.364,7.626 l 0.008,18.3 -5.115,0.452 c 0,0 -10.969,0.329 -13.581,0 L 42.62,110.379 C 31.084,107.68 22.591,98.738 20.066,86.3 l -0.8,-3.944 17.642,-4.964 0.692,4.895 C 38.417,87.928 42.62,94 49.971,94 c 6.123,0 12.748,-4.532 12.748,-11.865 0,-6.434 -4.463,-8.8 -12.367,-12.419 l -0.415,-0.19 -4.981,-2.162 C 34.993,62.848 24.442,56.846 24.269,42.49 V 42.144 A 24.69,24.69 0 0 1 27.521,29.744 25.936,25.936 0 0 1 42.62,18.05 V 0.424 C 54.156,0.326 55.039,0.394 61.335,1.5 v 16.723 a 28.319,28.319 0 0 1 15.792,13.6 l 1.9,3.528 -14.578,9.349 -2.266,-3.926 c -2.923,-5.068 -5.691,-6.867 -10.568,-6.867 -4.584,0 -9.444,2.992 -9.444,8.562 0,4.03 4.514,6.382 10.413,9.029 L 58.1,53.94 C 69,58.714 80.621,65.148 80.621,81.251 Z"
  })))))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "susde",
    viewBox: "0 0 94 93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9222 0.847386H46.9239C72.0683 0.847386 92.4519 21.2309 92.4519 46.3753V46.3771C92.4519 71.5215 72.0683 91.905 46.9239 91.905H46.9222C21.7778 91.905 1.39426 71.5215 1.39426 46.3771V46.3753C1.39426 21.2309 21.7778 0.847386 46.9222 0.847386Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.67719
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4843 8.22217C21.5865 11.6696 8.06689 27.416 8.06689 46.3201C8.06689 65.2241 21.5865 80.9705 39.4843 84.418V80.7817C23.5679 77.3888 11.6301 63.2485 11.6301 46.3201C11.6301 29.3916 23.5679 15.2513 39.4843 11.8585V8.22217ZM54.3146 11.8727V8.23505C72.1794 11.7087 85.6654 27.4394 85.6654 46.3201C85.6654 65.2007 72.1794 80.9315 54.3146 84.4051V80.7674C70.1977 77.3494 82.1023 63.2249 82.1023 46.3201C82.1023 29.4152 70.1977 15.2908 54.3146 11.8727Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3944 45.0239C55.3548 45.5881 57.651 46.6762 59.283 48.2882C60.915 49.8599 61.731 51.8748 61.731 54.3331V58.2019C61.731 61.1438 60.6683 63.5215 58.5429 65.335C56.4175 67.1082 53.6279 67.9948 50.1741 67.9948H48.9786V74.1607H44.8796V67.9948H43.6272C41.35 67.9948 39.3384 67.491 37.5926 66.4835C35.8467 65.4357 34.4804 63.985 33.4936 62.1312C32.5447 60.2371 32.0703 58.0609 32.0703 55.6026H36.1693C36.1693 58.1012 36.8525 60.1363 38.2188 61.708C39.6231 63.2394 41.4638 64.0051 43.741 64.0051H50.0603C52.2995 64.0051 54.1023 63.4812 55.4687 62.4334C56.835 61.3453 57.5182 59.9348 57.5182 58.2019V54.3331C57.5182 52.9629 57.0058 51.7942 55.981 50.8271C54.9942 49.8599 53.6279 49.2352 51.8821 48.9531L41.6346 47.1396C38.7501 46.6157 36.5109 45.5276 34.9168 43.8753C33.3228 42.223 32.5258 40.1476 32.5258 37.649V34.3847C32.5258 31.4428 33.5505 29.1054 35.6 27.3725C37.6874 25.5994 40.4391 24.7128 43.8549 24.7128H44.8796V18.5469H48.9786V24.7128H50.288C53.5141 24.7128 56.1139 25.7606 58.0875 27.8561C60.061 29.9114 61.0478 32.6317 61.0478 36.0169H56.9489C56.9489 33.8004 56.3416 32.0272 55.1271 30.6973C53.9126 29.3674 52.2995 28.7024 50.288 28.7024H43.8549C41.6915 28.7024 39.9646 29.2263 38.6742 30.2741C37.3838 31.2816 36.7386 32.6518 36.7386 34.3847V37.649C36.7386 39.0595 37.213 40.2483 38.1619 41.2155C39.1486 42.1827 40.496 42.8275 42.2039 43.1499L52.3944 45.0239Z",
    fill: "black"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "ena",
    viewBox: "0 0 135 135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.456,
    height: 134.458,
    rx: 67.2282,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5176 35.8374H51.0526L50.1029 36.9529L26.1247 65.1169L24.3745 67.1727L26.1247 69.2285L50.1029 97.3927L51.0526 98.5081H52.5176H95.6867H98.8579V95.3369V77.4322H92.5155V92.1657H59.4526L79.2744 69.2472L81.0686 67.1727L79.2744 65.0982L59.4526 42.1798H92.5155V56.9132H98.8579V39.0086V35.8374H95.6867H52.5176ZM52.5363 43.8786L32.7042 67.1727L52.5363 90.467L72.6831 67.1727L52.5363 43.8786Z",
    fill: "white"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "windows",
    viewBox: "0 0 34 34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#8C5BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 6,
    height: 6,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 6,
    height: 6,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 6,
    height: 6,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 6,
    height: 6,
    rx: 1,
    fill: "white"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "x-cross",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32,3.2228571 28.777143,0 16,12.777143 3.2228571,0 0,3.2228571 12.777143,16 0,28.777143 3.2228571,32 16,19.222857 28.777143,32 32,28.777143 19.222857,16 Z",
    strokeWidth: 2.2857
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM7.99998 12.4899L14.495 5.99497L13.505 5.00502L7.99998 10.51L5.49495 8.00502L4.505 8.99497L7.99998 12.4899Z",
    fill: "#7CFDA0"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "x-cross-circle",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM4.505 5.49497L8.01003 9L4.505 12.505L5.49495 13.495L8.99998 9.98995L12.505 13.495L13.495 12.505L9.98993 9L13.495 5.49497L12.505 4.50502L8.99998 8.01005L5.49495 4.50502L4.505 5.49497Z",
    fill: "#FF6C6C"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "link-vector",
    viewBox: "0 0 8 8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1H1M7 1V7M7 1L1 7",
    stroke: "white",
    strokeWidth: 2
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "interval-vector",
    viewBox: "0 0 10 16"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11.5V4.5L10 0H6H4H0L4 4.5V11.5L0 16H10L6 11.5Z",
    fill: "white"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "lens",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L15.5 14L14 15.5L11 12.5V11.71L10.73 11.44C9.59 12.41 8.11 13 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z",
    fill: "#D3D3E1"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "colored-caret-down",
    viewBox: "0 0 38 38"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_921)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_27_921",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 19C30 25.0751 25.0751 30 19 30C12.9249 30 8 25.0751 8 19C8 12.9249 12.9249 8 19 8C25.0751 8 30 12.9249 30 19Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30 19C30 25.0751 25.0751 30 19 30C12.9249 30 8 25.0751 8 19C8 12.9249 12.9249 8 19 8C25.0751 8 30 12.9249 30 19Z",
    fill: "#9143F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 19C29 24.5228 24.5228 29 19 29V31C25.6274 31 31 25.6274 31 19H29ZM19 29C13.4772 29 9 24.5228 9 19H7C7 25.6274 12.3726 31 19 31V29ZM9 19C9 13.4772 13.4772 9 19 9V7C12.3726 7 7 12.3726 7 19H9ZM19 9C24.5228 9 29 13.4772 29 19H31C31 12.3726 25.6274 7 19 7V9Z",
    fill: "white",
    fillOpacity: 0.2,
    mask: "url(#path-1-inside-1_27_921)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19 22L24 17L14 17L19 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_921",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.635294 0 0 0 0 0.219608 0 0 0 0 0.92549 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_921"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_921",
    result: "shape"
  }))))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C16.977 3 21 7.023 21 12C21 16.977 16.977 21 12 21C7.023 21 3 16.977 3 12C3 7.023 7.023 3 12 3ZM15.231 7.5L12 10.731L8.769 7.5L7.5 8.769L10.731 12L7.5 15.231L8.769 16.5L12 13.269L15.231 16.5L16.5 15.231L13.269 12L16.5 8.769L15.231 7.5Z",
    fill: "#7E859A"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "symbiotic",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12Z",
    fill: "#C0FD5C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20972 5.03415H18.7902V6.5561H6.73167V9.13171H18.9073V18.9659H5.32679V17.4439H17.3853V14.8683H5.20972V5.03415ZM17.3853 13.3463V10.6537H6.73167V13.3463H17.3853Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "alert",
    viewBox: "0 0 22 23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.5,
    r: 11,
    fill: "#FF5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.5H12V12.5H10V6.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14.5,
    width: 2,
    height: 2,
    fill: "white"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "question",
    viewBox: "0 0 13 13"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.4955 6.0125L7.9105 6.6105C7.4425 7.0785 7.15 7.475 7.15 8.45H5.85V8.125C5.85 7.4035 6.1425 6.7535 6.6105 6.2855L7.4165 5.4665C7.657 5.2325 7.8 4.9075 7.8 4.55C7.8 3.8285 7.215 3.25 6.5 3.25C6.15522 3.25 5.82456 3.38696 5.58076 3.63076C5.33696 3.87456 5.2 4.20522 5.2 4.55H3.9C3.9 3.86044 4.17393 3.19912 4.66152 2.71152C5.14912 2.22393 5.81044 1.95 6.5 1.95C7.18956 1.95 7.85088 2.22393 8.33848 2.71152C8.82607 3.19912 9.1 3.86044 9.1 4.55C9.1 5.122 8.866 5.6355 8.4955 6.0125ZM7.15 11.05H5.85V9.75H7.15V11.05ZM6.5 0C5.64641 0 4.80117 0.168127 4.01256 0.494783C3.22394 0.821439 2.50739 1.30023 1.90381 1.90381C0.684819 3.12279 0 4.77609 0 6.5C0 8.22391 0.684819 9.87721 1.90381 11.0962C2.50739 11.6998 3.22394 12.1786 4.01256 12.5052C4.80117 12.8319 5.64641 13 6.5 13C8.22391 13 9.87721 12.3152 11.0962 11.0962C12.3152 9.87721 13 8.22391 13 6.5C13 2.9055 10.075 0 6.5 0Z",
    fill: "#B3B3C0"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSprite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sprite.f3a06c2eb1ace39a140d572a8b9959a0.svg";